const calendarData = []
const isLoading = false
const bookingDetails = []
const billItemDetails = []
const userDetails = {}
const verifiedBookings = null
const bookingPaidStatusArray = ["APPROVED", "COMPLETE", "PAGO", "PAID", "WALLET", "COMPLETED"]
  const paymentMethodsAliases = {
    PIX: {
      title: 'Pix',
      slug: 'pix',
      value: 0.0,
      percentage: 0.0
    },
    CREDIT: {
      title: 'Crédito',
      slug: 'credit',
      value: 0.0,
      percentage: 0.0
    },
    DEBIT: {
      title: 'Débito',
      slug: 'debit',
      value: 0.0,
      percentage: 0.0
    },
    WALLET: {
      title: 'Carteira',
      slug: 'wallet',
      value: 0.0,
      percentage: 0.0
    },
    COD: {
      title: 'Local',
      slug: 'cod',
      value: 0.0,
      percentage: 0.0
    },
    COD_CREDIT: {
      title: 'Local - Crédito',
      slug: 'cod_credit',
      value: 0.0,
      percentage: 0.0
    },
    COD_DEBIT: {
      title: 'Local - Débito',
      slug: 'cod_debit',
      value: 0.0,
      percentage: 0.0
    },
    COD_PIX: {
      title: 'Local - Pix',
      slug: 'cod_pix',
      value: 0.0,
      percentage: 0.0
    },
    COD_DINHEIRO: {
      title: 'Local - Dinheiro',
      slug: 'cod_money',
      value: 0.0,
      percentage: 0.0
    },
    COD_CHEQUE: {
      title: 'Local - Cheque',
      slug: 'cod_cheque',
      value: 0.0,
      percentage: 0.0
    },
    COD_TRANSFER: {
      title: 'Local - Transferência',
      slug: 'cod_transfer',
      value: 0.0,
      percentage: 0.0
    },
    COD_BOLETO: {
      title: 'Local - Boleto',
      slug: 'cod_boleto',
      value: 0.0,
      percentage: 0.0
    },
    POS_CREDIT: {
      title: 'POS - Crédito',
      slug: 'pos_credit',
      value: 0.0,
      percentage: 0.0
    },
    POS_DEBIT: {
      title: 'POS - Débito',
      slug: 'pos_debit',
      value: 0.0,
      percentage: 0.0
    },
    POS_PIX: {
      title: 'POS - Pix',
      slug: 'pos_pix',
      value: 0.0,
      percentage: 0.0
    },
    POS_DINHEIRO: {
      title: 'POS - Dinheiro',
      slug: 'pos_money',
      value: 0.0,
      percentage: 0.0
    },
    POS_CORTESIA: {
      title: 'POS - Cortesia',
      slug: 'pos_cortesia',
      value: 0.0,
      percentage: 0.0
    },
    FREE_BOOKING: {
      title: 'POS - Cortesia',
      slug: 'free_booking',
      value: 0.0,
      percentage: 0.0
    },
    CORTESIA: {
      title: 'Cortesia',
      slug: 'cortesia',
      value: 0.0,
      percentage: 0.0
    },
    DINHEIRO: {
      title: 'Dinheiro',
      slug: 'money',
      value: 0.0,
      percentage: 0.0
    },
    'WOO-MERCADO-PAGO-CUSTOM': {
      title: 'Crédito',
      slug: 'credit',
      value: 0.0,
      percentage: 0.0
    },
    'GETNET-CREDITCARD': {
      title: 'Crédito',
      slug: 'credit',
      value: 0.0,
      percentage: 0.0
    },
    WOOCOMMERCE_OPENPIX_PIX: {
      title: 'Pix',
      slug: 'pix',
      value: 0.0,
      percentage: 0.0
    },
    UNKNOWN: {
      title: 'Formato não identificado',
      slug: 'unknown',
      value: 0.0,
      percentage: 0.0
    },
    MULTIPLE: {
      title: 'Multiplos pagamentos',
      slug: 'multiple',
      value: 0.0,
      percentage: 0.0
    },
    GERENCIANET_OFICIAL: {
      title: 'Pix',
      slug: 'pix',
      value: 0.0,
      percentage: 0.0
    }
}

export default {
  calendarData,
  isLoading,
  bookingDetails,
  billItemDetails,
  bookingPaidStatusArray,
  paymentMethodsAliases,
  verifiedBookings,
  userDetails,
}
